import type { Common } from '@libs/domain';
import type { CharacterCode, ImportType } from '@libs/enums';
import { characterCode } from '@libs/enums';
import type { OrEmpty } from '@ps-smart-cp/ppfw-client';

export class MstImport
  implements Pick<Common['schema'], 'characterCode' | 'file' | 'importClass' | 'jobComment'>
{
  protected constructor(
    readonly file: File | null,
    readonly jobComment: string,
    readonly importClass: OrEmpty<ImportType>,
    readonly characterCode: OrEmpty<CharacterCode>,
  ) {}

  static baseInit() {
    return new MstImport(null, '', '', characterCode.enum.ms932);
  }
}

export class MstImportFileRaw implements Pick<Common['record'], 'characterCode' | 'file'> {
  protected constructor(
    readonly file: File | null,
    readonly characterCode: string,
  ) {}

  static baseFromModel(file: File | null, mstImport: MstImport) {
    return new MstImportFileRaw(file, mstImport.characterCode);
  }
}
